import { Component, OnInit, OnDestroy, OnChanges, Input, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../core/user.service';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FirebaseUserModel } from '../core/user.model';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { RequestOfLeave } from '../objects/RequestOfLeave';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DocumentService } from '../document.service';
import { finalize, map, share } from 'rxjs/operators';
import * as jsPDF from 'jspdf';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { report } from '../../assets/requestPdf';
import { payrollList } from '../../assets/payrollList';
import { hours } from '../objects/HourList';

export interface User {
  NAME: string,
  PAYROLL: string,
  EMAIL: string
}

@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  user: FirebaseUserModel = new FirebaseUserModel();
  profileForm: FormGroup;
  requestOfLeaveForm: FormGroup;
  nameEstablished = false;
  today: number = Date.now();
  signedAgreement = false;
  fromDate: Date = new Date(Date.now());
  toDate: Date = new Date(Date.now());
  exchangeWith: string;
  settings = {
    bigBanner: true,
    timePicker: true,
    format: 'dd-MMMM-yyyy HH00',
    defaultOpen: false,
  };
  totalNumberOfHours: number = 0.0;
  payroll;
  requests: Observable<any[]>;
  reqCollection: AngularFirestoreCollection<RequestOfLeave>;
  reqs: Observable<RequestOfLeave[]>;
  subscription;
  firestoreConfig = {
    collection_endpoint: 'tasks'
  };
  uploadTask: AngularFireUploadTask;
  path;
  downloadURL;
  payrollValue;

  currentUser;
  currentUserPayroll;
  displayName
  isAdmin = false;
  doc;
  isLoading = false;

  @Input() form: FormGroup;
  @Input() minYear = new Date().getFullYear();
  fromDateForm: FormGroup;
  toDateForm: FormGroup;
  monthOpts: number[];
  dayOpts: number[];
  yearOpts: number[];
  hourOpts: string[];
  currentYear = new Date().getFullYear();

  selectedDate: Date;

  constructor(
    public userService: UserService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private location: Location,
    private fb: FormBuilder,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private http: HttpClient,
    private docService: DocumentService,
    private realtimeDB: AngularFireDatabase,
    private storage: AngularFireStorage,
    private chRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.checkAdmin();
    this.initializeDateForms();
    this.route.data.subscribe(routeData => {
      const data = routeData['data'];
      if (data) {
        this.user = data;
        this.createForm(this.user);
      }
    });

    this.getUser();

    this.getPayroll();
    this.requests = this.afs.collection(this.firestoreConfig.collection_endpoint).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as RequestOfLeave;
          data.id = a.payload.doc.id;
          return data;
        });
      }));

    this.requestOfLeaveForm = new FormGroup({
      fullName: new FormControl(),
      platoonNumber: new FormControl(),
      apparatus: new FormControl(),
      payrollNumber: new FormControl(),
      leaveRequested: new FormControl(),
      leaveReason: new FormControl(),
      totalNumberHours: new FormControl(),
      exchangeWithMember: new FormControl(),
      agreement: new FormControl(),
    });
  }

  range(start, end): number[] {
    return Array.from({ length: ((end + 1) - start) }, (v, k) => k + start);
  }

  createFormControl(): FormControl {
    return new FormControl('', Validators.required);
  }

  /* Grab entire set of employee payrolls  */
  setPayroll(val) {
    this.payrollValue = val;
    console.log(this.payrollValue.NAME);
    console.log(this.payrollValue.PAYROLL);
  }

  initializeDateForms() {
    this.monthOpts = this.range(1, 12);
    this.dayOpts = this.range(1, 31);
    this.yearOpts = this.range(this.minYear, new Date().getFullYear() + 1);
    this.hourOpts = hours;

    this.fromDateForm = new FormGroup({
      month: this.createFormControl(),
      day: this.createFormControl(),
      year: this.createFormControl(),
      hour: this.createFormControl(),
      minute: this.createFormControl()
    });

    this.toDateForm = new FormGroup({
      month: this.createFormControl(),
      day: this.createFormControl(),
      year: this.createFormControl(),
      hour: this.createFormControl(),
      minute: this.createFormControl()
    });
  }

  createForm(user) {
    this.profileForm = this.fb.group({
      name: [user.name, Validators.required],
      payrollNumber: [user.payroll, Validators.required]
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout() {
    this.authService.doLogout()
      .then((res) => {
        this.location.back();
      }, (error) => {
      });
  }

  leftPad(number, targetLength) {
    let output = number + '';
    while (output.length < targetLength) {
      output = '0' + output;
    }
    return output;
  }

  formatMonth(month): string {
    return month < 10 ? '0' + month : '' + month;
  }

  displayDate() {
    this.toDate = new Date(this.toDate);
    this.fromDate = new Date(this.fromDate);
  }

  downloadRequestPDF(reqOfLeave) {
    this.doc = new jsPDF();
    const img = report;
    this.doc.addImage(img, 'JPEG', 0, 0, 210, 290);
    console.log(reqOfLeave);

    const startDay = reqOfLeave.startDay;
    const startMonth = reqOfLeave.startMonth;
    const startTime = reqOfLeave.startTime;
    const endDay = reqOfLeave.endDay;
    const endMonth = reqOfLeave.endMonth;
    const endTime = reqOfLeave.endTime;

    const dateOfCreation = reqOfLeave.dateOfCreation;
    const dateOfCreationHours = reqOfLeave.timeOfCreation;
    const fullName = this.formatFullName(reqOfLeave.fullName);
    const leaveRequested = reqOfLeave.leaveRequested;
    const leaveReason = reqOfLeave.leaveReason;
    const platoon = reqOfLeave.platoonNumber;
    const totalHours = this.totalNumberOfHours;
    const apparatus = reqOfLeave.apparatus;
    const exchangeWith = this.requestOfLeaveForm.controls['exchangeWithMember'].value;
    // console.log('Exchange with NAME: ' + exchangeWith.NAME);
    // console.log('Exchange with PAYROLL: ' + exchangeWith.PAYROLL);

    this.doc.text(dateOfCreation, 34, 52);
    this.doc.text(platoon, 110, 52);
    this.doc.text(apparatus, 168, 52);
    this.doc.text(fullName, 53, 62);
    this.doc.text(this.currentUser.PAYROLL, 155, 62);

    switch (leaveRequested) {
      case 'compTime':
        this.doc.text('x', 83, 80);
        break;
      case 'Personal Leave currentYear':
        this.doc.text('x', 83, 92);
        break;
      case 'Personal Leave lastYear':
        this.doc.text('x', 83, 104);
        break;
      case 'Special Leave':
        this.doc.text('x', 83, 114);
        this.doc.text(leaveReason, 125, 114);
        break;
      case 'Exchange of Time':
        this.doc.text('x', 83, 128);
        break;
      case 'Union Business':
        this.doc.text('x', 83, 136);
        break;
      case 'School':
        this.doc.text('x', 83, 148);
        break;
    }

    // Set Personal Leave years
    this.doc.text(this.minYear.toString(), 131, 92);
    this.doc.text((this.minYear - 1).toString(), 131, 104);

    // Start Date
    this.doc.text(startMonth + '/' + startDay + '/' + reqOfLeave.fromDate.getFullYear().toString().slice(-2), 37, 164);
    this.doc.text(startTime.toString(), 65, 164);
    // End Date
    this.doc.text(endMonth + '/' + endDay + '/' + reqOfLeave.toDate.getFullYear().toString().slice(-2), 95, 164);
    this.doc.text(endTime.toString(), 124, 164);
    // Total Hours
    this.doc.text(totalHours.toString(), 180, 164);
    if (exchangeWith) {
      this.doc.text(exchangeWith.NAME, 75, 178);
      this.doc.text(exchangeWith.PAYROLL.toString(), 162, 178);
    }
    this.doc.text(fullName, 42, 204);
    this.doc.text(dateOfCreation, 128, 204);
    this.doc.text(dateOfCreationHours, 162, 204);
    const blob = this.doc.output('dataurl');
    this.uploadDoc(blob, this.doc, reqOfLeave); // NEED to get this downloadURL before we saveRequest
  }

  async uploadDoc(blob, doc, request) {
    this.isLoading = true;

    this.path = `unsignedRequests/${request.requestId}.pdf`;
    const fileRef = this.storage.ref(this.path);


    await fileRef.putString(blob, 'data_url');
    fileRef.getDownloadURL().subscribe(url => {
      this.downloadURL = url;

      request.downloadURL = url;
      this.isLoading = false;
      this.docService.addRequest(request);
    }, (error => {
      this.isLoading = false;
      console.log(error);
    }));
  }

  getUser() {
    this.realtimeDB.list('participants/' + this.afAuth.auth.currentUser.uid).valueChanges().subscribe(data => {
      this.currentUser = data[0];
      this.displayName = this.currentUser.FIRST_NAME + ' ' + this.currentUser.LAST_NAME;
    });
  }

  createRequestOfLeaveObject(value) {
    if (this.totalNumberOfHours <= 0) {
      alert("The amount of hours selected is invalid. Please choose a proper time range.");
      return;
    }

    const request: RequestOfLeave = value;
    const now = new Date(Date.now());
    const monthNames = [
      '1', '2', '3',
      '4', '5', '6', '7',
      '8', '9', '10',
      '11', '12'
    ];
    const day = now.getDate();
    const monthIndex = now.getMonth();
    const year = now.getFullYear();

    request.dateOfCreation = monthNames[monthIndex] + '/' + day + '/' + year;
    request.username = this.afAuth.auth.currentUser.displayName;
    request.firstName = request.fullName.split(" ")[0];
    request.lastName = request.fullName.split(" ")[1];
    request.email = this.afAuth.auth.currentUser.email;
    request.uid = this.afAuth.auth.currentUser.uid;
    request.payrollNumber = this.currentUser.PAYROLL;
    request.fromDate = this.getDateValue(this.fromDateForm);
    request.fromYear = this.getYear(this.fromDateForm).toString();
    request.toYear = this.getYear(this.toDateForm).toString();
    request.toDate = this.getDateValue(this.toDateForm);
    request.totalNumberHours = this.totalNumberOfHours;
    request.startDay = this.leftPad(this.fromDateForm.controls['day'].value, 2);
    request.startMonth = this.formatMonth(parseInt(this.fromDateForm.controls['month'].value) + 1);
    request.startTime = this.fromDateForm.controls['hour'].value + '' + this.leftPad(this.fromDateForm.controls['minute'].value, 2);
    request.endDay = this.leftPad(this.toDateForm.controls['day'].value, 2);
    request.timeOfCreation = this.calculateCurrentTime();
    request.endMonth = this.formatMonth(parseInt(this.toDateForm.controls['month'].value) + 1);
    request.endTime = this.toDateForm.controls['hour'].value + '' + this.leftPad(this.toDateForm.controls['minute'].value, 2);
    request.requestId = this.afs.createId();
    this.downloadRequestPDF(request);
    console.log(request);
    alert('Your PDF is available below. Details are in the Open Requests page. To officially finish your submission, you must call the fire chief and confirm at: (518)382-5132');
  }

  getPayroll() {
    this.payroll = payrollList;
  }

  downloadPDFFile(url) {
    window.open(url, '_blank');
  }

  getDateValue(form) {
    let date = new Date(form.controls['year'].value, form.controls['month'].value, form.controls['day'].value,
      form.controls['hour'].value, form.controls['minute'].value, 0, 0);
    console.log(date);
    return date;
  }

  getYear(form) {
    return form.controls['year'].value;
  }

  convertDateToUTC(date) {
    console.log(date.getUTCHours());
    console.log(date.getUTCMinutes());
    let convertedDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    console.log(convertedDate);
    return convertedDate;
  }

  checkAdmin() {
    var currentEmail = <String>this.afAuth.auth.currentUser.email;
    this.realtimeDB.list('admins/').valueChanges().subscribe(data => {
      Object.keys(data).forEach(user => {
        var incomingEmail = <String>data[user].email;
        if (incomingEmail.toUpperCase() === currentEmail.toUpperCase()) {
          this.isAdmin = true;
        }
      });
    }, (error) => {
      console.log(error);
      return false;
    }, () => {
      return false;
    });
    return false;
  }

  calculateCurrentTime() {
    var time = new Date(Date.now());
    return ("0" + time.getHours()).slice(-2) + ("0" + time.getMinutes()).slice(-2);
  }

  isDateRangeAllowed(event) {
    const date1 = new Date('December 24, 2020 08:00:00');
    const date2 = new Date('December 24, 2020 23:59:59');

    let startDate = this.getDateValue(this.fromDateForm);
    let endDate = this.getDateValue(this.toDateForm);

    let isDateForbidden = (startDate < date1 && date1 < endDate) || (startDate < date2 && date2 < endDate);
    if(isDateForbidden) {
      event.preventDefault();
      alert("You cannot choose Christmas Eve for time off.");
      return;
    }
    return true;
  }

  formatFullName(fullName: String): String {
    if(fullName == null || fullName == "") {
      fullName = this.displayName;
    }
    fullName = fullName.trim();
    if((fullName.split(" ").length - 1) !== 1) {
      if(!confirm("Full Name field is not in 'FirstName LastName' format. End result may look different. Do you want to continue?")) {
        throw new Error("Full Name does not fit expected format. Aborting.");
      }
    }
    let firstName = fullName.split(" ")[0];
    let lastName = fullName.split(" ")[1];
    return lastName + ", " + firstName; 
  }

}
